import React, { useState } from 'react';
import BoltIcon from '@mui/icons-material/Bolt';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ReplayIcon from '@mui/icons-material/Replay';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import SettingsIcon from '@mui/icons-material/Settings';

import './Home.scss';

import SquareButton from 'src/components/common/SquareButton';
import BackButton from 'src/components/homeView/BackButton';
import VersionsInfo from 'src/components/homeView/VersionsInfo';
import LobbyList from 'src/components/homeView/LobbyList';
import LobbyController from 'src/components/homeView/LobbyController';
import ThinSeparator from 'src/components/common/ThinSeparator';
import JoinLobby from 'src/components/homeView/JoinLobby';

import Matchmaking from './Matchmaking';
import CreateLobby from './CreateLobby';
import RejoinGame from './RejoinGame';
import Leaderboard from './Leaderboard';
import Settings from './Settings';

type subViewType =
  | 'home'
  | 'create-lobby'
  | 'rejoin-game'
  | 'matchmaking'
  | 'leaderboard'
  | 'settings';

const Home = () => {
  const [subView, setSubView] = useState<subViewType>('home');

  const SUB_VIEW_COMPONENTS = {
    home: (
      <>
        <JoinLobby />
        <ThinSeparator angle="horizontal">or</ThinSeparator>
        <LobbyList />
        <div className="home-menu">
          <SquareButton
            text="Quick Play (Matchmaking)"
            colorPreset="green"
            noHeight={true}
            onClick={() => setSubView('matchmaking')}
            Icon={BoltIcon}
          />
          <SquareButton
            text="Create Lobby"
            colorPreset="blue"
            noHeight={true}
            onClick={() => setSubView('create-lobby')}
            Icon={PlaylistAddIcon}
          />
          <SquareButton
            text="Rejoin Game"
            colorPreset="red"
            noHeight={true}
            onClick={() => setSubView('rejoin-game')}
            Icon={ReplayIcon}
          />
          <SquareButton
            text="Leaderboard (WIP)"
            colorPreset="yellow"
            noHeight={true}
            onClick={() => setSubView('leaderboard')}
            Icon={LeaderboardIcon}
          />
          <SquareButton
            text="Settings"
            colorPreset="lightblue"
            noHeight={true}
            onClick={() => setSubView('settings')}
            Icon={SettingsIcon}
          />
        </div>
      </>
    ),
    matchmaking: <Matchmaking />,
    'create-lobby': <CreateLobby />,
    'rejoin-game': <RejoinGame />,
    leaderboard: <Leaderboard />,
    settings: <Settings />,
  };

  const subViewComponent = SUB_VIEW_COMPONENTS[subView];

  return (
    <div className="Home">
      <LobbyController>
        {subView !== 'home' && (
          <div className="backbutton-holder">
            <BackButton onClick={() => setSubView('home')} />
          </div>
        )}
        {subViewComponent}
        <VersionsInfo />
      </LobbyController>
    </div>
  );
};

export default Home;
